import css from 'styled-jsx/css';
import { colors, screen } from 'components/styles/variables';
import phone from 'public/static/images/home/phone-graphic.jpg';
import streetWreath from 'public/static/images/home/street-wreath.svg';
import cnetWreath from 'public/static/images/home/cnet-wreath.svg';
import appStorePromo from 'public/static/images/app-store-promo.svg';
import googlePlayBadge from 'public/static/images/google-play-badge.svg';

export default css`
  .mobile-app-download {
    padding: 0px 27px;
    display: flex;
    flex-direction: column;
  }

  .outer-flex-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  @media (min-width: ${screen.smMin}) {
    .outer-flex-container {
      align-items: flex-start;
      width: initial;
    }

    .mobile-app-download {
      width: 750px;
      margin-right: auto;
      margin-left: auto;
      padding-left: 15px;
      padding-right: 15px;
      flex-direction: row;
      justify-content: space-between;
    }
  }

  @media (min-width: ${screen.mdMin}) {
    .mobile-app-download {
      width: 970px;
    }
  }

  @media (min-width: ${screen.lgMin}) {
    .mobile-app-download {
      width: 1170px;
      padding: 0px 87px 47px 120px;
    }
  }

  .header {
    margin: 0;
    padding: 0;
    font-size: 23px;
    letter-spacing: 0.19px;
    font-weight: 700;
    text-align: center;
  }

  @media (min-width: ${screen.smMin}) {
    .header {
      font-size: 30px;
    }
  }

  @media (min-width: ${screen.mdMin}) {
    .header {
      font-size: 34px;
    }
  }

  @media (min-width: ${screen.lgMin}) {
    .header {
      font-size: 36px;
    }
  }

  .sub-header {
    margin: 0;
    padding: 0;
    font-size: 23px;
    font-weight: 600;
  }

  span {
    color: ${colors.ALR1};
  }

  .phone-image-mobile {
    background-size: cover;
    width: 221px;
    height: 269px;
    margin-top: 26px;
  }

  .phone-image-mobile-in-view {
    background-image: url(${phone});
  }

  @media (min-width: ${screen.smMin}) {
    .phone-image-mobile {
      display: none;
    }
  }

  .phone-image-desktop {
    display: none;
  }

  @media (min-width: ${screen.smMin}) {
    .phone-image-desktop {
      display: block;
      background-size: cover;
      width: 225px;
      height: 275px;
    }

    .phone-image-desktop-in-view {
      background-image: url(${phone});
    }
  }

  @media (min-width: ${screen.mdMin}) {
    .phone-image-desktop {
      width: 286px;
      height: 349px;
    }
  }

  .flex-container {
    display: flex;
    justify-content: space-around;
    margin-top: 26px;
    width: 100%;
  }

  @media (min-width: ${screen.smMin}) {
    .flex-container {
      justify-content: normal;
      width: initial;
    }
  }

  .wreath-container {
    margin-bottom: -65px;
    max-width: 350px;
  }

  @media (min-width: ${screen.smMin}) {
    .wreath-container {
      margin-bottom: 0;
      max-width: none;
    }
  }

  .cnet-wreath {
    width: 48%;
    background-size: contain;
    background-repeat: no-repeat;
    height: 0;
    padding-top: 37.5%;
    max-width: 152px;
  }

  .cnet-wreath-in-view {
    background-image: url(${cnetWreath});
  }

  .street-wreath {
    width: 48%;
    background-size: contain;
    background-repeat: no-repeat;
    height: 0;
    padding-top: 37.5%;
    max-width: 152px;
  }

  .street-wreath-in-view {
    background-image: url(${streetWreath});
  }

  .app-store-container {
    max-width: 350px;
  }

  @media (min-width: ${screen.smMin}) {
    .street-wreath {
      background-size: cover;
      width: 195px;
      height: 73px;
      margin-right: 19px;
      max-width: none;
      padding-top: 0;
    }

    .cnet-wreath {
      background-size: cover;
      width: 195px;
      height: 73px;
      max-width: none;
      padding-top: 0;
    }

    .app-store-container {
      margin-top: 40px;
      max-width: none;
    }
  }

  @media (min-width: ${screen.mdMin}) {
    .street-wreath {
      width: 243px;
      height: 91px;
      margin-right: 24px;
    }

    .cnet-wreath {
      width: 243px;
      height: 91px;
    }

    .app-store-container {
      margin-top: 48px;
    }
  }

  .app-store-promo {
    background-size: contain;
    background-repeat: no-repeat;
    width: 44.25%;
    max-width: 144px;
    height: 0;
    padding-top: 32.39%;
  }

  .app-store-promo-in-view {
    background-image: url(${appStorePromo});
  }

  .google-play {
    background-size: contain;
    background-repeat: no-repeat;
    width: 49.5%;
    max-width: 161px;
    height: 0;
    padding-top: 29.81%;
  }

  .google-play-in-view {
    background-image: url(${googlePlayBadge});
  }

  @media (min-width: ${screen.smMin}) {
    .app-store-promo {
      background-size: cover;
      margin-right: 24px;
      width: 144px;
      height: 48px;
      padding-top: 0;
    }

    .google-play {
      background-size: cover;
      width: 161px;
      height: 48px;
      padding-top: 0;
    }
  }
`;
